import * as React from "react";
import { useAsync } from "react-use";
import { useApi } from "./ApiContainer";
import { createContainer } from "./StateContainer";

type Schema = {
  [key: string]: string[];
};

const useSchemaContainerState = (): {
  schema: Schema | undefined;
  loading: boolean;
} => {
  const { postgrest } = useApi();
  const { value, loading } = useAsync(async () => {
    const { data } = await postgrest.rpc("columns");
    return Object.fromEntries(
      data.map((row) => [row.table_name, row.column_names])
    );
  });
  return { schema: value, loading };
};
const SchemaContainerState = createContainer(useSchemaContainerState);

export const SchemaContainer: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <SchemaContainerState.Provider>{children}</SchemaContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useSchema = SchemaContainerState.useContainer;
